import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CustomFieldsActions } from './custom-fields.actions';
import { CustomFieldService } from '../../services/custom-field.service';

@Injectable()
export class CustomFieldsEffects {
  private actions$ = inject(Actions);
  private svc = inject(CustomFieldService);

  loadDefinitions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldsActions.loadDefinitions),
      mergeMap(({ entityType, includeInactive }) =>
        this.svc.getDefinitions(entityType, includeInactive ?? false).pipe(
          map(definitions => CustomFieldsActions.loadDefinitionsSuccess({ definitions })),
          catchError(err => of(CustomFieldsActions.loadDefinitionsFailure({ error: err.message })))
        )
      )
    )
  );

  createDefinition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldsActions.createDefinition),
      mergeMap(({ dto }) =>
        this.svc.createDefinition(dto).pipe(
          map(definition => CustomFieldsActions.createDefinitionSuccess({ definition })),
          catchError(err => of(CustomFieldsActions.createDefinitionFailure({ error: err.message })))
        )
      )
    )
  );

  updateDefinition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldsActions.updateDefinition),
      mergeMap(({ id, dto }) =>
        this.svc.updateDefinition(id, dto).pipe(
          map(definition => CustomFieldsActions.updateDefinitionSuccess({ definition })),
          catchError(err => of(CustomFieldsActions.updateDefinitionFailure({ error: err.message })))
        )
      )
    )
  );

  deleteDefinition$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomFieldsActions.deleteDefinition),
      mergeMap(({ id }) =>
        this.svc.deleteDefinition(id).pipe(
          map(() => CustomFieldsActions.deleteDefinitionSuccess({ id })),
          catchError(err => of(CustomFieldsActions.deleteDefinitionFailure({ error: err.message })))
        )
      )
    )
  );
}
